import React, { useContext } from "react";
import { InfoContext, Group } from "../../InfoContext";
import { AuthContext } from "../../AuthContext";

interface GroupManageCardProps {
  group: Group;
  season_id: number;
  isMobile?: boolean;
}

const RenderTeams = (
  group: Group,
  isMobile: boolean,
  penaltyLookup: { [key: number]: number }
) => {
  let placement = 1;
  const { role } = useContext(AuthContext);

  return group.teams
    .slice()
    .sort((a, b) => {
      const pointsA = a.wins * 3 + a.draws - (penaltyLookup[a.id] || 0);
      const pointsB = b.wins * 3 + b.draws - (penaltyLookup[b.id] || 0);

      if (pointsA !== pointsB) {
        return pointsB - pointsA;
      }

      const diffA = a.goals_scored - a.goals_conceded;
      const diffB = b.goals_scored - b.goals_conceded;

      if (diffA !== diffB) {
        return diffB - diffA;
      }

      if (a.goals_scored !== b.goals_scored) {
        return b.goals_scored - a.goals_scored;
      }

      return a.goals_conceded - b.goals_conceded;
    })
    .map((team) => (
      <div
        key={placement}
        className="px-2 m-1 border-b last-of-type:border-b-0 border-gray-600 flex"
      >
        <p className="flex justify-start w-10 sticky left-2 py-2 backdrop-blur-lg">
          {role === "ADMIN" ? team.id : placement++}
        </p>
        <p className="w-40 sm:w-52 whitespace-nowrap truncate sticky left-10 backdrop-blur-lg h-full py-2">
          {team.name}
          {penaltyLookup[team.id] ? "*" : ""}
        </p>
        <div className="grow" />
        <p className="w-8 flex items-center justify-center text-gray-300">
          {team.matches}
        </p>{" "}
        <p className="w-8 flex items-center justify-center font-bold ">
          {team.wins * 3 + team.draws - (penaltyLookup[team.id] || 0)}
        </p>
        <p className="w-8 flex items-center justify-center text-gray-300">
          {team.goals_scored - team.goals_conceded}
        </p>
        {!isMobile && (
          <>
            <p className="w-8 flex items-center justify-center text-gray-300">
              {team.wins}
            </p>
            <p className="w-8 flex items-center justify-center text-gray-300">
              {team.draws}
            </p>
            <p className="w-8 flex items-center justify-center text-gray-300">
              {team.losses}
            </p>
            <p className="w-8 flex items-center justify-center text-gray-300">
              {team.goals_scored}
            </p>
            <p className="w-8 flex items-center justify-center text-gray-300">
              {team.goals_conceded}
            </p>
          </>
        )}
      </div>
    ));
};

const GroupManageCard: React.FC<GroupManageCardProps> = ({
  group,
  season_id,
  isMobile = false,
}) => {
  const { getSeasonById, getPenaltyLookup } = useContext(InfoContext);
  const penaltyLookup = getPenaltyLookup(season_id);
  const { role } = useContext(AuthContext);

  return (
    <div
      key={group.id}
      className="bg-white/10 rounded-xl p-4 text-white max-w-full"
    >
      <h3 className="text-2xl font-bold mb-4">
        {group.name} ({getSeasonById(season_id)?.name})
      </h3>
      {role === "ADMIN" && (
        <>
          <p>ID: {group.id}</p>
          <p>Season ID: {group.season_id}</p>
        </>
      )}
      <div className="flex overflow-x-auto ">
        <div className="flex flex-col">
          <div className="px-2 border-b m-1 flex text-grey-300">
            <p className="flex justify-start w-10 sticky left-2 backdrop-blur-lg py-2">
              Pos
            </p>
            <p className="w-40 sticky left-10 backdrop-blur-lg py-2">Name</p>
            <p className="grow" />
            <p className="w-8 flex items-center justify-center">MP</p>
            <p className="w-8 flex items-center justify-center">Pts</p>
            <p className="w-8 flex items-center justify-center">GD</p>
            {!isMobile && (
              <>
                <p className="w-8 flex items-center justify-center">W</p>
                <p className="w-8 flex items-center justify-center">D</p>
                <p className="w-8 flex items-center justify-center">L</p>
                <p className="w-8 flex items-center justify-center">GF</p>
                <p className="w-8 flex items-center justify-center">GA</p>
              </>
            )}
          </div>
          {RenderTeams(group, isMobile, penaltyLookup)}
        </div>
      </div>
      <p className="text-xs mt-2">
        * Teams with more than two refereeing penalties receive -1&nbsp;point.
      </p>
    </div>
  );
};

export default GroupManageCard;
